import { render, staticRenderFns } from "./ApprovalDetail.vue?vue&type=template&id=7b2092d6&scoped=true"
import script from "./ApprovalDetail.vue?vue&type=script&lang=js"
export * from "./ApprovalDetail.vue?vue&type=script&lang=js"
import style0 from "./ApprovalDetail.vue?vue&type=style&index=0&id=7b2092d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2092d6",
  null
  
)

export default component.exports